import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "../GroupBarChart/GroupBarChart.css";

const GroupBarChart = () => {
  const [chartHeight, setChartHeight] = useState(320);

  // Adjust height dynamically based on screen width
  useEffect(() => {
    const updateChartHeight = () => {
      setChartHeight(window.innerWidth <= 1300 ? 290 : 320);
    };

    updateChartHeight(); // Set initial height
    window.addEventListener("resize", updateChartHeight);

    return () => {
      window.removeEventListener("resize", updateChartHeight);
    };
  }, []);

  const options = {
    chart: {
      type: "column",
      height: chartHeight, // Use dynamic height
    },
    xAxis: {
      categories: ["Comp A", "Comp B", "Comp C", "Comp D"],
      title: {
        text: "Companies",
        align: "low",
        x: 0,
        y: 5,
        style: {
          color: "#999",
          fontSize: "14px",
        },
      },
      labels: {
        style: {
          color: "#999",
          fontSize: "14px",
        },
      },
      lineWidth: 1,
      lineColor: "#999",
    },
    yAxis: {
      min: 10,
      max: 100,
      title: {
        text: "Performance Metrics",
        align: "high",
        rotation: 90,
        x: -10,
        y: 245,
        style: {
          color: "#999",
          fontSize: "14px",
        },
      },
      labels: {
        style: {
          color: "#999",
          fontSize: "14px",
        },
      },
      lineWidth: 1,
      lineColor: "#999",
    },
    series: [
      {
        name: "Compliance",
        data: [55, 85, 92, 70],
        color: "#a5bcfc",
      },
      {
        name: "Quality",
        data: [81, 35, 89, 91],
        color: "#dcdcdc",
      },
      {
        name: "Delivery",
        data: [75, 60, 40, 50],
        color: "#c7d7fe",
      },
    ],
    plotOptions: {
      column: {
        grouping: true,
        borderWidth: 0,
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      style: {
        color: "#999",
        fontSize: "14px",
      },
    },
  };

  return (
    <section className="section">
      <div className="container">
        <div className="groupbar-header">
          <h1>Company Perf: Compliance, Quality, Delivery</h1>
        </div>

        <div className="groupbar-parent">
          <div className="group-count-wrapper">
            <div>
              <i className="fa-solid fa-circle" style={{ color: "#a5bcfc" }}></i>{" "}
              Compliance
            </div>
            <div>
              <i className="fa-solid fa-circle" style={{ color: "#dcdcdc" }}></i>{" "}
              Quality
            </div>
            <div>
              <i className="fa-solid fa-circle" style={{ color: "#c7d7fe" }}></i>{" "}
              Delivery
            </div>
          </div>

          <div className="groupbar-container">
            <HighchartsReact highcharts={Highcharts} options={options} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GroupBarChart;
